export const color = {
  brown: '#5c450b',
  black: '#000000',
  dark: '#2d3747',
  darkBlue: '#3a465a',
  darkBlueActive: '#202938',
  cream: '#eaeef1',
  light: '#ffffff',
  lightGrey: '#b6c4d7',
  lightGrey2: '#d7dae0',
  lightCream: '#f2f5f9',
  greyInactive: '#586a85',
  grey: '#4d5d77',
  greyLight: '#777e8e',
  darkGrey: '#808fa4',
  greyBorder: '#869ab8',
  greyBorder2: '#ced7e9',
  tableBorder: '#B8D6E1',
  greyIcon: '#bdbdbd',
  red: '#f15d5d',
  tangerine: '#FFA000',
  error: '#F64E45',
  yellow: '#FF8F00',
  yellow2: '#FFB300',
  amber: '#f5a623',
  blueActive: '#2e71d7',
  blueActive2: '#4485b4',
  blue: '#6495ed',
  blue2: '#5a83a1',
  blue3: '#64A8F6',
  lightBlue: '#F5F9FF',
  blueLight: '#84bdd3',
  blueLightHover: '#e2f1fc',
  blueGrey: '#a2bccd',
  green: '#74c120',
  newGreen: '#1E88E5',
  softGreen: '#74C21F',
  text: {
    dark: '#414c5f',
    dark2: '#36454f',
    dark3: '#2c3646',
    light2: '#cbdce9',
    light3: '#c2c7cc',
  },
  borderLightGrey: '#ced7e8',
  darkScroll: '#5f6f80',
  chipBackground: '#515b6e',
  blueReports: '#2f91e3',
  greenReports: '#63bc66',
  redReports: '#f1524b',
  lightRed: '#f7e7ea',
  lightGreen: '#e7f2e1',
  grey2: '#aabad2',
  veryDarkGrey: '#242c39',
  gray3: '#c0c8d6',
  darkPastelGreen: '#43c43e',
  greyishBrown: '#4a4a4a',
  grayBlue: '#4a90e2',
  darkMint: '#41bf6b',
  lightBlueGrey: '#bfcbde',
  blueGreyPh: '#7b8dab',
  textColorModalWindow: '#323642',
  lightGreyBlue: '#a4b3ca',
  lightGreyPh: '#4b576c',
  bluePh: '#4e95fe',
  skyBlue: '#9BC7E8',
  lightPeriwinkle: '#d9e0ed',
  veryLightBlue: '#eaedf3',
  aqua: '#17d1c8',
  inputBorder: '#9eb8d6',
  activeBlue: '#46a5ea',
  white_2: '#f1f1f1',
  activeIcon: '#ffcd50',
  rose: '#f5b1ca',
  reportsBlue: '#5ab0ee',
  slateGrey: '#586772',
  lightGrey3: '#424d60',
  echoBlue: '#A1ADC2',
  aliceBlue: '#E3F2FD',
  lavenderBlush: '#FFECF0',
  cobalt: '#0D47A1',
  fireBrick: '#BA2C2B',
  nightRiderGray: '#323232',
  violetRed: '#E84644',
  mystic: '#E0E4EB',
  grayish: '#8192AE',
  hazy: '#c1cdd6',
  asphalt: '#222937',
  violationRed: '#FF300B',
  violationOrange: '#9e6300',
  violationGreen: '#249408',
  activeMenuItemBlue: '#EAF7FF',
  greyard: '#e9eff3',
  metalGrey: '#f6f6f5',
  headerGrey: '#a2baca',
  white3: '#f9f9fb',
  //In case if colors will be used for new theme
  buttonPrimary: '#2D8FDA',
  buttonTextPrimary: '#FFF',
  textPrimary: '#202938',
  cancelLabel: '#808EA2',
};

export const colorShades = {
  yellow: {
    [50]: '#0F0C00',
    [100]: '#291F00',
    [200]: '#664E00',
    [300]: '#997500',
    [400]: '#CC9C00',
    [500]: '#FFC400',
    [600]: '#FFCF33',
    [700]: '#FFDB66',
    [800]: '#FFE799',
    [900]: '#FFF3CC',
    [950]: '#FFF9E6',
    [990]: '#FFFDF5',
  },
  gray: {
    [50]: '#000000',
    [100]: '#151515',
    [200]: '#212121',
    [300]: '#424242',
    [400]: '#616161',
    [500]: '#757575',
    [600]: '#9E9E9E',
    [700]: '#BDBDBD',
    [800]: '#E0E0E0',
    [900]: '#EEEEEE',
    [950]: '#F5F5F5',
    [990]: '#FAFAFA',
  },
  blueGrey: {
    [50]: '#0B0E11',
    [100]: '#181D25',
    [200]: '#28303E',
    [300]: '#3B485E',
    [400]: '#50607C',
    [500]: '#64789B',
    [600]: '#8393AF',
    [700]: '#A2AEC3',
    [800]: '#C1C9D7',
    [900]: '#E0E4EB',
    [950]: '#ECEFF3',
    [990]: '#F6F7F9',
  },
  red: {
    [50]: '#160406',
    [100]: '#34090D',
    [200]: '#5B1018',
    [300]: '#861823',
    [400]: '#B6202F',
    [500]: '#D71D30',
    [600]: '#E74B5B',
    [700]: '#EE818C',
    [800]: '#F4AEB5',
    [900]: '#F7D4D7',
    [950]: '#FBE4E6',
    [990]: '#FDF2F3',
  },
  blue: {
    [50]: '#001019',
    [100]: '#012032',
    [200]: '#014065',
    [300]: '#026097',
    [400]: '#0287D4',
    [500]: '#0398FC',
    [600]: '#33B3FD',
    [700]: '#68C6FD',
    [800]: '#A4DDFE',
    [900]: '#CDEAFE',
    [950]: '#EAF7FF',
    [990]: '#F5FBFF',
  },
  turquoise: {
    [50]: '#021012',
    [100]: '#06272D',
    [200]: '#0B4E5B',
    [300]: '#117488',
    [400]: '#169BB6',
    [500]: '#1CC2E3',
    [600]: '#53D0EA',
    [700]: '#77DAEE',
    [800]: '#A4E7F4',
    [900]: '#D2F3F9',
    [950]: '#E4F8FC',
    [990]: '#F1FBFD',
  },
  green: {
    [50]: '#03110A',
    [100]: '#082B18',
    [200]: '#0F5731',
    [300]: '#178249',
    [400]: '#20B666',
    [500]: '#2FDA7F',
    [600]: '#52E094',
    [700]: '#7DE8AF',
    [800]: '#A8F0CA',
    [900]: '#D4F7E4',
    [950]: '#E9FBF2',
    [990]: '#F6FDFA',
  },
  orange: {
    [50]: '#190C01',
    [100]: '#321D01',
    [200]: '#643A02',
    [300]: '#965603',
    [400]: '#C87304',
    [500]: '#FC9003',
    [600]: '#FBA637',
    [700]: '#FCBC69',
    [800]: '#FDD39B',
    [900]: '#FEE9CD',
    [950]: '#FEF4E6',
    [990]: '#FFFBF5',
  },
  purple: {
    [50]: '#0A0416',
    [100]: '#15082B',
    [200]: '#290F57',
    [300]: '#3E1782',
    [400]: '#531FAD',
    [500]: '#6826D9',
    [600]: '#8652E0',
    [700]: '#A47DE8',
    [800]: '#C2A8F0',
    [900]: '#E1D4F7',
    [950]: '#F0E9FB',
    [990]: '#F9F6FD',
  },
  magenta: {
    [50]: '#18020E',
    [100]: '#2F041C',
    [200]: '#5F0739',
    [300]: '#8E0B55',
    [400]: '#BE0E72',
    [500]: '#ED128E',
    [600]: '#F141A5',
    [700]: '#F471BB',
    [800]: '#F8A0D2',
    [900]: '#FBD0E8',
    [950]: '#FDE3F1',
    [990]: '#FEF1F8',
  }
};
